import axios from 'axios';
import { httpApi } from './http';
import type { UserCardsAdminListParams, UserCardsAdminListResponse } from '../types/userCard';
import type { CardUsageStatsParams, CardUsageStatsResponse } from '../types/userCardStats';

const api = httpApi;

export class UserCardService {
  static async listAdminUserCards(params: UserCardsAdminListParams = {}): Promise<UserCardsAdminListResponse> {
    try {
      const response = await api.get<UserCardsAdminListResponse>('/user-cards/admin', {
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 25,
          q: params.q ?? '',
          sortBy: params.sortBy ?? 'created',
          sortOrder: params.sortOrder ?? 'desc',
        },
      });

      if (!response.data) {
        throw new Error('No data received from server');
      }

      if (!response.data.success) {
        throw new Error(response.data.error || response.data.message || 'API request failed');
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const apiError = (error.response?.data as any)?.error || (error.response?.data as any)?.message;

        if (apiError) {
          throw new Error(apiError);
        }

        if (status) {
          throw new Error(`Server error: ${status}`);
        }

        if (error.request) {
          throw new Error('Network error: Unable to connect to server');
        }
      }

      throw new Error('Failed to fetch user cards');
    }
  }

  static async getCardUsageStats(params: CardUsageStatsParams = {}): Promise<CardUsageStatsResponse> {
    try {
      const response = await api.get<CardUsageStatsResponse>('/user-cards/stats/cards', {
        params: {
          includeInactive: params.includeInactive ?? true,
        },
      });

      if (!response.data) {
        throw new Error('No data received from server');
      }

      if (!response.data.success) {
        throw new Error(response.data.error || response.data.message || 'API request failed');
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const apiError = (error.response?.data as any)?.error || (error.response?.data as any)?.message;

        if (apiError) {
          throw new Error(apiError);
        }

        if (status) {
          throw new Error(`Server error: ${status}`);
        }

        if (error.request) {
          throw new Error('Network error: Unable to connect to server');
        }
      }

      throw new Error('Failed to fetch card usage stats');
    }
  }
}
